import _ from 'underscore';

const getAddressString = (address) => {
  let addressString = '';
  if (address && typeof address === 'object') {
    Object.keys(address).forEach(key => { if (address[key]) addressString += `${address[key]}, ` });
    addressString = addressString.replace(/, $/, '');
  }
  return addressString;
}

const hasAddress = (address) => {
  return ( address && !_.isEmpty(address.city) && !_.isEmpty(address.state) );
};

export { getAddressString, hasAddress }
